import { Row, Col, Form, Button, Tab, Table, InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Css from './Customer.module.css';
import { useEffect, useState } from "react";
import ApiConection from "api_ref/ApiConection";
import { ConvertDateToText, DisplayPaging, RandomId, TextDate } from "components/MyControl";
import ATSApiConnection from 'api_ref/ATSApiConnection';
import swal from "sweetalert";
import Layout4Admin1 from "components/layout/Layout4Admin1";
import Footer4Bottom1 from "components/layout/Foot4Bottom1";
import UtilClass from "api_ref/UtilClass";

export default function Company() {
    const api = new ApiConection();
    const atsApi = new ATSApiConnection();
    const util = new UtilClass();

    const [dataTable, setDataTable] = useState({
        arr_table: [],
        record_start: 0,
        record_end: 0,
        record_count: 0,
        page_count: 0
    });

    const [search, setSearch] = useState({
        register_number: '',
        user_name: '',
        company_name: '',
        tax_id: '',
        site_url: '',
        create_date_from: '',
        create_date_to: '',
        effective_date_from: '',
        effective_date_to: '',
        expiry_date_from: '',
        expiry_date_to: '',
        launch: '',
        active_dcaas: '',
        active: '',
        page: util.getCombinedSessionStorage('/company','page') ?? 1,
        size: util.getCombinedSessionStorage('/company','size') ?? 10,
        order_by: 'EffectiveDate',
        order_mode: 'desc',
    });

    const [paymentStatus, setPaymentStatus] = useState([]);
    const [filterDispaly, setFilterDisplay] = useState(false);
    const [loading, setLoading] = useState(false);

    const nav = useNavigate();

    const handleSetSearch = (name, value) => {
        setSearch(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSetDataTable = (name, value) => {
        setDataTable(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSizeTableChange = (event) => {
        const { name, value } = event.target;

        util.setCombinedSessionStorage('/company','page',1);
        util.setCombinedSessionStorage('/company','size',value);

        handleSetSearch('page', 1);
        handleSetSearch('size', value);
    }

    const handlePagingChange = (page_no) => {

        util.setCombinedSessionStorage('/company','page',page_no);

        handleSetSearch('page', page_no);
    }

    const handleQuickSearch = (event) => {
        const { name, value } = event.target;
        handleSetSearch('company_name', value);
        handleSetSearch('page', 1);
        handleSetSearch('size', search.size);
    }

    const handleFullSearch = (event) => {
        const { name, value } = event.target;
        handleSetSearch(name, value);
        handleSetSearch('page', 1);
        handleSetSearch('size', search.size);
    }

    const callPaymentStatus = async () => {
        const response = await api.getData('api/master/payment-status');
        if (response.status === true) {
            setPaymentStatus(response.data);
        }
    }

    const handleSetOrderBy = (event) => {
        const name = event.target.dataset.name;

        handleSetSearch('order_by', name);
        handleSetSearch('page', 1);
        if (search?.order_mode == 'asc')
            handleSetSearch('order_mode', 'desc');
        else
            handleSetSearch('order_mode', 'asc');
    }

    const getOrderBy = (name) => {
        if (search?.order_by === name) {
            if (search?.order_mode === 'asc') {
                return <i className="ms-2 fa-solid fa-sort-down text-danger"></i>
            } else {
                return <i className="ms-2 fa-solid fa-sort-up text-danger"></i>
            }
        }
    }
    /*
        const handleCallCreateSite = async(register_number,user_id,company_name,site_url)=>{
            await swal("ลงทะเบียนกับ ISO-DCaaS ?",{
                buttons: {
                    cancel:'ยกเลิก',
                    confirm:{
                        text:"ตกลง",
                        value:"confirm"
                    }
                }
            })
            .then( async(value) => {
                swal('กำลังดำเนินการ' , {
                    button: false,
                  });
                return await callATSCreateSite(register_number,user_id,company_name,site_url);
            })
            .then( (result)=>{
                console.log(result);
                console.log(result.message);
                if(result.status === true)
                    swal('สำเร็จ');
                else
                    swal('ไม่สำเร็จ : ' + result.message);
            });
        }

        const callATSCreateSite = async(register_number,user_id,company_name,site_url)=>{
            const response_user = await api.getData(`api/users/${user_id}`);
            //console.log(response_user);
            if(response_user.status === true){
                const random_password = RandomId(8);

                let ats_data = {
                    company:company_name,
                    userName:response_user.data.login_name,
                    userEmail:response_user.data.email,
                    userPassword:random_password,
                    subDomain:site_url,
                }
                try{
                    const ats_reponse = await atsApi.postData(`api/NewTenant`,ats_data);
                    console.log(ats_reponse);
                    if(ats_reponse.status == 'completed'){
                        const responseQt = await api.getData(`api/quontation/register/${register_number}`);

                        let data = {
                            password : random_password,
                            is_approved : true
                        }

                        //--- อนุญาต ให้เข้า web site
                        await api.putData(`api/quontation/${responseQt.data.quontation_number}/register/${register_number}/launch`,data);

                        //--- อัพเดท tenant

                        let data_newTenant = {
                            subDomain : site_url,
                            tenantStatus: 1,
                            tenantMaxUser : responseQt.data.user_valume,
                            tenantMaxDisk : responseQt.data.storage_valume * 8000000000
                        }
                        const ats_reponse_update = await atsApi.postData(`api/UpdateTenant`,data_newTenant);

                        return {status:true,message:''};
                    }else{
                        return {status:false,message:ats_reponse.message};
                    }
                }catch(e){
                    console.log(e);
                    return {status:false,message:e};
                }
            }else{
                return {status:false,message:response_user.message};
            }
        }
    */
    const callApiRegister = async () => {
        setLoading(true);

        let data = {
            search: {
            },
            pagination: {
                page: search.page,
                size: search.size,
                order_by: search.order_by,
                order_mode: search.order_mode
            }
        }

        if (search.register_number != '')
            data.search.register_number = search.register_number;

        if (search.user_name != '')
            data.search.user_name = search.user_name;

        if (search.company_name != '')
            data.search.company_name = search.company_name;

        if (search.site_url != '')
            data.search.site_url = search.site_url;

        if (search.effective_date_from != '')
            data.search.effective_date_from = search.effective_date_from;
        if (search.effective_date_to != '')
            data.search.effective_date_to = search.effective_date_to;
        if (search.expiry_date_from != '')
            data.search.expiry_date_from = search.expiry_date_from;
        if (search.expiry_date_to != '')
            data.search.expiry_date_to = search.expiry_date_to;

        if (search.due_date_from != '')
            data.search.due_date_from = search.due_date_from;
        if (search.due_date_to != '')
            data.search.due_date_to = search.due_date_to;
        if (search.paid_date_from != '')
            data.search.paid_date_from = search.paid_date_from;
        if (search.paid_date_to != '')
            data.search.paid_date_to = search.paid_date_to;

        if (search.payment_status_id != '')
            data.search.payment_status_id = search.payment_status_id;
        if (search.audit_status_id != '')
            data.search.audit_status_id = search.audit_status_id;

        if (search.active != '')
            data.search.active = (search.active == true || search.active == 'true');

        if (search.active_dcaas != '')
            data.search.active_dcaas = (search.active_dcaas == true || search.active_dcaas == 'true');

        if (search.launch != '')
            data.search.launch = (search.launch == true || search.launch == 'true');

        const response_pagination = await api.postData('api/Register/pagination', data);
        //debugger;
        if (response_pagination.status == true) {
            handleSetDataTable('record_start', response_pagination.data.record_start);
            handleSetDataTable('record_count', response_pagination.data.record_count);
            handleSetDataTable('page_count', response_pagination.data.page_count);
        }
        const response_result = await api.postData('api/Register/result', data);

        //console.log(response_result);
        if (response_result.status == true) {
            handleSetDataTable('arr_table', response_result.data);
        } else {
            handleSetDataTable('arr_table', []);
        }

        let record_end = response_pagination.data.record_start + (search.size - 1);
        if (record_end > response_pagination.data.record_count) {
            record_end = response_pagination.data.record_count;
        }

        handleSetDataTable('record_end', record_end);

        setLoading(false);
    }

    const CurencyByte = (byte) => {
        if (byte == undefined) {
            return;
        }
        if (byte >= 1024 * 1024 * 1024) {
            let gb = byte / (1024 * 1024 * 1024);
            return gb.toFixed(2) + ' GB';
        } else if (byte >= 1024 * 1024) {
            let mb = byte / (1024 * 1024);
            return mb.toFixed(2) + ' MB';
        } else if (byte >= 1024) {
            let kb = byte / 1024;
            return kb.toFixed(2) + ' KB';
        } else {
            return byte.toFixed(2) + ' bytes';
        }
    }

    const getWaringColor = (current,total) =>{
        let persent = 25;
        let v25Persent = Math.round(persent * total / 100 );

        if(current >= (total - v25Persent))
            return 'text-danger';
        else
            return 'text-success';
    }

    useEffect(() => {
        callPaymentStatus();
    }, [])
    useEffect(() => {
        if (search !== undefined) {
            const delay = setTimeout(() => {
                // เรียกใช้ฟังก์ชันสำหรับการคำนวณผลลัพธ์ที่ต้องการ
                callApiRegister();
            }, 500);

            return () => clearTimeout(delay);
        }
    }, [search])

    const handleChange = (register_number) => {
        nav(`detail/${register_number}`);
    }
    return (
        <Layout4Admin1 role="admin">
            <div className={Css.Block_Transparent}>
                <div className={Css.Graph_Group}>
                    <div className={Css.Graph_Box + ' shadow'}>
                        <div className={Css.Content}>
                            <div className={Css.Header}>
                                <div className="d-flex">
                                    <h6 className="d-flex align-items-center">รายการลูกค้า</h6>
                                    <div className="flex-fill">
                                        <Form.Group as={Row}>
                                            <Form.Label column sm={4} className="text-end">ค้นหา</Form.Label>
                                            <Col>
                                                <InputGroup>
                                                    <Form.Control placeholder="บริษัท" id={'txtQuickSearch'} value={search.company_name}
                                                        disabled={filterDispaly}
                                                        onChange={(event) => handleQuickSearch(event)} />
                                                    <Button variant="outline-secondary" onClick={event => setFilterDisplay(!filterDispaly)}>
                                                        {
                                                            filterDispaly === true &&
                                                            <i className="fa-solid fa-arrow-up-short-wide"></i>
                                                        }
                                                        {
                                                            filterDispaly === false &&
                                                            <i className="fa-solid fa-arrow-down-short-wide"></i>
                                                        }
                                                        <span></span>
                                                    </Button>
                                                    <Button>
                                                        <i className="fa-solid fa-magnifying-glass"></i>
                                                    </Button>
                                                </InputGroup>

                                            </Col>
                                        </Form.Group>

                                    </div>
                                </div>
                                {
                                    filterDispaly === true &&
                                    <div className="d-flex bg-">
                                        <div className="w-100 bg-light p-3">
                                            <Row className="mb-2">
                                                <Col>
                                                    <Form.Label>รหัสลูกค้า</Form.Label>
                                                    <Form.Control name={'register_number'} value={search.register_number} onChange={handleFullSearch} />
                                                </Col>
                                                <Col>
                                                    <Form.Label>ชื่อบริษัท</Form.Label>
                                                    <Form.Control name={'company_name'} value={search.company_name} onChange={handleFullSearch} />
                                                </Col>
                                                <Col>
                                                    <Form.Label>ชื่อเว็บไซต์</Form.Label>
                                                    <Form.Control name={'site_url'} value={search.site_url} onChange={handleFullSearch} />
                                                </Col>
                                                <Col>
                                                    <Form.Label>ชื่อผู้ติดต่อ</Form.Label>
                                                    <Form.Control name={'user_name'} value={search.user_name} onChange={handleFullSearch} />
                                                </Col>
                                            </Row>
                                            <Row className="mb-2">
                                                <Col>
                                                    <Form.Label>วันที่เริ่มแพ็กเกจ</Form.Label>
                                                    <InputGroup className="flex-nowrap">
                                                        <InputGroup.Text>จาก</InputGroup.Text>
                                                        <TextDate name={'effective_date_from'} onChange={handleFullSearch} />
                                                        <InputGroup.Text>ถึง</InputGroup.Text>
                                                        <TextDate name={'effective_date_to'} onChange={handleFullSearch} />
                                                    </InputGroup>
                                                </Col>
                                                <Col>
                                                    <Form.Label>วันที่สิ้นสุดแพ็กเกจ</Form.Label>
                                                    <InputGroup className="flex-nowrap">
                                                        <InputGroup.Text>จาก</InputGroup.Text>
                                                        <TextDate name={'expiry_date_from'} onChange={handleFullSearch} />
                                                        <InputGroup.Text>ถึง</InputGroup.Text>
                                                        <TextDate name={'expiry_date_to'} onChange={handleFullSearch} />
                                                    </InputGroup>
                                                </Col>
                                            </Row>
                                            <Row className="mb-2">
                                                <Col>
                                                    <Form.Label>วันที่ครบกำหนด</Form.Label>
                                                    <InputGroup className="flex-nowrap">
                                                        <InputGroup.Text>จาก</InputGroup.Text>
                                                        <TextDate name={'due_date_from'} onChange={handleFullSearch} />
                                                        <InputGroup.Text>ถึง</InputGroup.Text>
                                                        <TextDate name={'due_date_to'} onChange={handleFullSearch} />
                                                    </InputGroup>
                                                </Col>
                                                <Col>
                                                    <Form.Label>วันที่ชำระเงิน</Form.Label>
                                                    <InputGroup className="flex-nowrap">
                                                        <InputGroup.Text>จาก</InputGroup.Text>
                                                        <TextDate name={'paid_date_from'} onChange={handleFullSearch} />
                                                        <InputGroup.Text>ถึง</InputGroup.Text>
                                                        <TextDate name={'paid_date_to'} onChange={handleFullSearch} />
                                                    </InputGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Form.Label>สถานะชำระ</Form.Label>
                                                    <Form.Select name={'payment_status_id'} value={search.payment_status_id} onChange={handleFullSearch} >
                                                        <option value={''}>ทั้งหมด</option>
                                                        {
                                                            paymentStatus?.map((obj, index) => (
                                                                <option key={index} value={obj.id}>{obj.name}</option>
                                                            ))
                                                        }
                                                    </Form.Select>
                                                </Col>
                                                <Col>
                                                    <Form.Label>สถานะสร้าง Tenent</Form.Label>
                                                    <Form.Select name={'launch'} value={search.launch} onChange={handleFullSearch}>
                                                        <option value={''}>ทั้งหมด</option>
                                                        <option value={true}>สร้างสำเร็จ</option>
                                                        <option value={false}>สร้างไม่สำเร็จ</option>
                                                    </Form.Select>
                                                </Col>
                                                <Col>
                                                    <Form.Label>สถานะ ISO-DCaaS</Form.Label>
                                                    <Form.Select name={'active_dcaas'} value={search.active_dcaas} onChange={handleFullSearch}>
                                                        <option value={''}>ทั้งหมด</option>
                                                        <option value={true}>อนุญาตใช้งาน</option>
                                                        <option value={false}>ไม่อนุญาตใช้งาน</option>
                                                    </Form.Select>
                                                </Col>
                                                <Col>
                                                    <Form.Label>สถานะ Portal</Form.Label>
                                                    <Form.Select name={'active'} value={search.active} onChange={handleFullSearch}>
                                                        <option value={''}>ทั้งหมด</option>
                                                        <option value={true}>อนุญาตใช้งาน</option>
                                                        <option value={false}>ไม่อนุญาตใช้งาน</option>
                                                    </Form.Select>
                                                </Col>

                                            </Row>
                                        </div>

                                    </div>
                                }

                            </div>

                            <div className={Css.Content + ' position-relative'}>
                                {
                                    loading &&
                                    <div className="position-absolute w-100 h-100 bg-white bg-opacity-50" style={{ zIndex: 5 }}>
                                        <div className="d-flex justify-content-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="table-responsive border rounded">

                                    <table className="table text-nowrap mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th ></th>
                                                <th>#</th>
                                                <th className="text-start" data-name={'RegisterNumber'} onClick={event => handleSetOrderBy(event)}>รหัสลูกค้า{getOrderBy('RegisterNumber')}</th>
                                                <th className="text-start" data-name={'CompanyName'} onClick={event => handleSetOrderBy(event)} style={{ width: '300px' }}>บริษัท{getOrderBy('CompanyName')}</th>
                                                <th className="text-start" data-name={'UserName'} onClick={event => handleSetOrderBy(event)}>ผู้ติดต่อ{getOrderBy('UserName')}</th>
                                                <th className="text-start" data-name={'PackageName'} onClick={event => handleSetOrderBy(event)} style={{ width: '300px' }}>แพ็กเกจ{getOrderBy('PackageName')}</th>
                                                <th className="text-start" data-name={'PackageName'} onClick={event => handleSetOrderBy(event)} style={{ width: '300px' }}>ปริมาณใช้งาน{getOrderBy('PackageName')}</th>
                                                <th className="text-center" data-name={'CreateDate'} onClick={event => handleSetOrderBy(event)}>วันที่สมัคร{getOrderBy('CreateDate')}</th>
                                                <th className="text-center" data-name={'EffectiveDate'} onClick={event => handleSetOrderBy(event)}>วันที่ซื้อแพ็กเกจ{getOrderBy('EffectiveDate')}</th>
                                                <th className="text-center" data-name={'ExpiryDate'} onClick={event => handleSetOrderBy(event)}>วันที่หมดอายุแพ็กเกจ{getOrderBy('ExpiryDate')}</th>
                                                <th className="text-center" data-name={'QuontationTransactionDueDate'} onClick={event => handleSetOrderBy(event)}>วันที่กำหนดชำระ{getOrderBy('QuontationTransactionDueDate')}</th>
                                                <th className="text-center" data-name={'PaymentStatusName'} onClick={event => handleSetOrderBy(event)}>สถานะชำระ{getOrderBy('PaymentStatusName')}</th>
                                                <th className="text-center" data-name={'PaidDate'} onClick={event => handleSetOrderBy(event)}>วันที่ชำระ{getOrderBy('PaidDate')}</th>
                                                <th className="text-center" data-name={'Launch'} onClick={event => handleSetOrderBy(event)}>Tenent{getOrderBy('Launch')}</th>
                                                <th className="text-center" data-name={'ActiveDcaas'} onClick={event => handleSetOrderBy(event)}>ISO-DCaaS{getOrderBy('ActiveDcaas')}</th>
                                                <th className="text-center" data-name={'Active'} onClick={event => handleSetOrderBy(event)}>Portal{getOrderBy('Active')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                dataTable.arr_table.length > 0 &&
                                                dataTable.arr_table.map((obj, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                <button type='button' className="btn btn-info text-white" title="ดูข้อมูล" onClick={event => handleChange(obj.register_number)} >
                                                                    <i className="fa-solid fa-magnifying-glass"></i>
                                                                </button>
                                                            </td>
                                                            <td>{dataTable.record_start + index}</td>
                                                            <td className="text-start">{obj.register_number}</td>
                                                            <td className="text-start">
                                                                {obj.company_name}<br />
                                                                <i className="fa-solid fa-location-dot text-black-50 me-2"></i>
                                                                <Form.Text>{obj.company_address}</Form.Text>
                                                                <br />
                                                                <i className="fa-solid fa-globe text-black-50 me-2"></i>
                                                                <Form.Text>{obj.full_site_url}</Form.Text>
                                                                {
                                                                    obj.company_tel != '' &&
                                                                    <>
                                                                        <br />
                                                                        <i className="fa-solid fa-phone text-black-50 me-2"></i>
                                                                        <Form.Text>{obj.company_tel}</Form.Text>
                                                                    </>
                                                                }

                                                            </td>
                                                            <td className="text-start">
                                                                {obj.quontation.user_name}
                                                                {
                                                                    (obj.quontation?.user_email != '' && obj.quontation?.user_email != undefined) &&
                                                                    <>
                                                                        <br />
                                                                        <i className="fa-solid fa-envelope text-black-50 me-2"></i>
                                                                        <Form.Text>{obj.quontation.user_email}</Form.Text>
                                                                    </>
                                                                }

                                                                {
                                                                    (obj.quontation?.user_tel != '' && obj.quontation?.user_tel != undefined) &&
                                                                    <>
                                                                        <br />
                                                                        <i className="fa-solid fa-phone text-black-50 me-2"></i>
                                                                        <Form.Text>{obj.quontation.user_tel}</Form.Text>
                                                                    </>
                                                                }

                                                            </td>
                                                            <td className="text-start">{obj.quontation.package_master_name_short}
                                                                
                                                                {
                                                                    (obj?.quontation?.package_master_period_name != undefined) &&
                                                                    <>
                                                                        <br />
                                                                        <Form.Text>{obj.quontation.package_master_period_name}</Form.Text>
                                                                    </>
                                                                }
                                                                {
                                                                    (obj.quontation.effective_date != undefined) &&
                                                                    <>
                                                                        <br />
                                                                        <Form.Text>{ConvertDateToText(obj.quontation.effective_date) + ' - ' + ConvertDateToText(obj.quontation.expiry_date)}</Form.Text>

                                                                    </>
                                                                }

                                                            </td>
                                                            <td className="text-start">
                                                                {
                                                                    (obj?.quontation?.package_master_period_name != undefined) &&
                                                                    <>
                                                                        
                                                                        <table>
                                                                            <tr>
                                                                                <td className="text-center"><i className="fa-solid fa-users text-black-50 me-3"></i></td>
                                                                                <td className="text-end"> <span className={getWaringColor(obj.quontation.user_volume_used,obj.quontation.user_volume)}>{obj.quontation.user_volume_used} User</span></td>
                                                                                <td className="text-end"> <span className="me-2">/</span>
                                                                                    <span className="fw-medium">{obj.quontation.user_volume} User</span>
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="text-center"><i className="fa-solid fa-database text-black-50 me-3"></i></td>
                                                                                <td className="text-end"><span className={getWaringColor(obj.quontation.storage_volume_used,obj.quontation.storage_volume * 1024 * 1024 * 1024)}>{ CurencyByte(obj.quontation.storage_volume_used)}</span></td>
                                                                                <td className="text-end">
                                                                                    <span className="me-2">/</span>
                                                                                    <span className="fw-medium">{obj.quontation.storage_volume} GB</span>
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                    </>
                                                                }
                                                                
                                                            </td>
                                                            <td>{ConvertDateToText(obj.create_date)}</td>
                                                            <td>{ConvertDateToText(obj.quontation.effective_date)}</td>
                                                            <td>{ConvertDateToText(obj.quontation.expiry_date)}</td> 
                                                            <td>{ obj.quontation.package_type != 'free' && ConvertDateToText(obj.quontation.due_date) }</td>
                                                            <td className="text-start">
                                                                {
                                                                    obj.quontation.payment_status_id == 3 &&
                                                                    <>
                                                                        <div className="ps-2 pe-2 text-center text-white bg-success rounded mb-1">{obj.quontation.payment_status_name}</div>
                                                                    </>
                                                                }
                                                                {
                                                                    (obj.quontation.payment_status_id != 3 && obj.quontation.payment_status_id != undefined) &&
                                                                    <>
                                                                        <div className="ps-2 pe-2 text-center text-white bg-warning rounded mb-1">{obj.quontation.payment_status_name}</div>
                                                                    </>
                                                                }
                                                                {
                                                                    obj.quontation.package_type != 'free' && (obj.quontation.audit_status_id != 4 && obj.quontation.audit_status_id != undefined) &&
                                                                    <>
                                                                        <div className="mt-2 s-2 pe-2 text-center text-white bg-warning rounded mb-1">{obj.quontation.audit_status_name}</div>
                                                                    </>
                                                                }
                                                                {
                                                                    obj.quontation.package_type != 'free' && obj.quontation.audit_status_id == 4 &&
                                                                    <>
                                                                        <div className="ps-2 pe-2 text-center text-white bg-success rounded mb-1">{obj.quontation.audit_status_name}</div>
                                                                    </>
                                                                }
                                                            </td>
                                                            <td>{obj.quontation.package_type != 'free' && ConvertDateToText(obj.quontation.paid_date)}</td>
                                                            <td>{obj.launch == true ? <i className="fa-regular fa-circle-check fs-6 text-success" title="สำเร็จ"></i>

                                                                : <i className="fa-regular fa-circle-xmark fs-6 text-danger" title="ไม่สำเร็จ"></i>}

                                                            </td>
                                                            <td>{obj.active_dcaas == true ? <i className="fa-regular fa-circle-check fs-6 text-success" title="สำเร็จ"></i>

                                                                : <i className="fa-regular fa-circle-xmark fs-6 text-danger" title="ไม่สำเร็จ"></i>}

                                                            </td>
                                                            <td>{obj.active == true ? <i className="fa-regular fa-circle-check fs-6 text-success" title="สำเร็จ"></i>
                                                                : <i className="fa-regular fa-circle-xmark fs-6 text-danger" title="ไม่สำเร็จ"></i>}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <DisplayPaging rec_start={dataTable.record_start}
                                    rec_end={dataTable.record_end}
                                    rec_count={dataTable.record_count}
                                    onSizeChange={handleSizeTableChange}
                                    cur_page={search.page}
                                    size={search.size}
                                    page_count={dataTable.page_count}
                                    onPagingChange={handlePagingChange} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout4Admin1>
    )
}